<template>
  <div class="container">
    <AppNavbar
      :placeholder="true"
      :options="options"
      :zIndex="999"
      :title="title"
    >
      <div slot="right">
        <span class="history" @click="bindHistory">已填问卷</span>
      </div>
    </AppNavbar>
    <van-tabs v-model="active" @change="bindChange">
      <van-tab
        :title="item.type_name"
        v-for="(item, index) in questionData"
        :key="index"
      >
      </van-tab>
    </van-tabs>
    <div
      v-for="(item, index) in questionData"
      :key="index"
      class="list"
      v-show="active == index"
    >
      <div class="scroll" ref="scroll">
        <van-pull-refresh v-model="item.refreshing" @refresh="onRefresh">
          <van-list
            v-model="item.loading"
            :finished="item.finished"
            finished-text="没有更多了"
            @load="onLoad(false)"
          >
            <div class="question-list">
              <ListItem
                v-for="(item1, index1) in item.list"
                :key="index1"
                :data="item1"
                @click="bindClick"
              />
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import ListItem from './components/list-item.vue'
export default {
  name: 'common-questions-home',
  components: {
    AppNavbar,
    ListItem
  },
  data() {
    return {
      options: {},
      title: '全部问卷',
      active: 0,
      questionData: []
    }
  },
  created() {
    this.getTab()
  },
  activated() {
    this.initScrollTop()
  },
  mounted() {},
  methods: {
    //初始化滚动条位置
    initScrollTop() {
      this.$nextTick(() => {
        let arr = this.$refs.scroll
        if (arr && arr.length) {
          arr.map((item, index) => {
            item.scrollTop = this.questionData[index].scrollTop
            console.log(this.questionData[index].scrollTop)
          })
        }
        console.dir(arr)
      })
    },
    bindHistory() {
      this.$router.push({
        path: '/common-questions/my-question'
      })
    },
    bindChange(active) {
      this.initScrollTop()
      if (
        !this.questionData[this.active].list.length &&
        !this.questionData[this.active].finished
      ) {
        this.onLoad()
      }
    },
    getTab() {
      this.$http.getBaseApp('que/QueBase/initIndex', {}).then((res) => {
        res = res.data
        if (res.code == 200) {
          res.data = res.data || []
          res.data = res.data.filter((item) => {
            return item.tag_is_show
          })
          res.data.unshift({
            id: 0,
            tag_is_show: 1,
            type_name: '全部'
          })
          let obj = {
            page: 1,
            scrollTop: 0, //滚动条高度
            refreshing: false,
            loading: false,
            finished: false,
            list: []
          }
          res.data.map((item) => {
            for (let key in obj) {
              item[key] = obj[key]
            }
          })
          this.questionData = res.data
          this.$nextTick(() => {
            let arr = this.$refs.scroll
            arr.map((item) => {
              item.addEventListener('scroll', (e) => {
                this.questionData[this.active].scrollTop = e.target.scrollTop
              })
            })
          })
          this.onLoad()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onRefresh() {
      this.questionData[this.active].finished = false
      this.questionData[this.active].page = 1
      this.onLoad(true)
    },
    onLoad(cover) {
      let active = this.active
      this.questionData[active].loading = true
      let params = {
        page: this.questionData[active].page,
        que_type: this.questionData[active].id
      }
      this.$http
        .getBaseApp('que/QueBase/getQueList', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.map((item) => {
              item.que_title = item.que_title.replace(/<\s*br\s*\/*\s*>/g, ',')
            })
            if (cover) {
              this.questionData[active].list = res.data
            } else {
              this.questionData[active].list = this.questionData[
                active
              ].list.concat(res.data)
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.questionData[active].loading = false
          this.questionData[active].refreshing = false
          //因没有分页暂时请求一次直接结束
          this.questionData[active].finished = true
        })
    },
    bindClick(item) {
      this.$router.push({
        path: '/common-questions/start',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.scroll {
  background: #f9f9f9;
}

.question-list {
  padding: 20px 16px;
}

.list {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;

  .scroll {
    height: 100%;
    overflow-y: scroll;
  }
}

.history {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.8);
  line-height: 20px;
}

::v-deep .van-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 20px;
}

::v-deep .van-tab--active {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 20px;
}

::v-deep .van-tabs__line {
  width: 16px;
  height: 4px;
  background: #6236ff;
  border-radius: 2px;
}
</style>
